import { CoreIcon } from '../core-icon';
import logoPoweredByAutopassSVG from '../../assets/logos/logo-powered-by-autopass.svg';
import type { IconProps } from '../core-icon';

export const LogoPoweredByAutopassIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={logoPoweredByAutopassSVG} {...props} />;
};
